"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import { Sidemenu } from "./Sidemenu";
import { Topnav } from "./Topnav";
import { Inbox } from "./Inbox";
import { Leads } from "./Leads";
import { PopupImport } from "./PopupImport";
import { IncomingCall } from "./IncomingCall";
import * as _utils from "./utils";
import _styles from "./PageHome.module.css";
import { UploadProvider } from "../contexts/UploadContext";

export function PageHome({ as: _Component = _Builtin.Block,
  dialerHandler = () => { },
  dialerLoading = false,
  interactionsData = [],
  dataCollectHandler = () => { },
  handleSendingMessage = () => { },
  transcriptionData = [],
  handleTranscriptMessage = () => { },
  handleClickInteraction = () => { },
  callStatus = "",
  handleHangUp = () => { },
  handleAcceptCall = () => { },
  inboxes = [],
  handleClickUserInbox = () => { },
  currentLead = {},
  baseInfo = {},
  incomingCallInfo = {},
  isFetchingInteractions = false,
  isFetchingTanscriptions = false,
  loadMore = () => { },
  isLoadingMore = false,
  leadsData = [],
  sampleImportData = [],
  leadTableLoading = false,
  leadLoading = false,
  history = [],
  historyLoading = false,
  handlerRowClick = () => { },
  handleHistoryClick = () => { },
  interLeadsLoading = false,
  interDataLeads = [],
  transLeadData = [],
  transLeadsLoading = false,
  handleClickInterLeads = () => { },
  leadBaseInfo = {},
  loadMoreLeads = () => { },
  isLeadsLoadingMore = false,
  leadskey = {},
  loadMoreInter = () => { },
  inputDevices = [],
  outputDevices = [],
  onDeviceSelect = () => { },
  agentStatus = "offline",
  onStatusChange = () => { },
  callErrorMsg = "",
  openModalKeypad = () => { },
  interactionId = "",
  filter = () => { },
  agentId = "",
  handleStatusChange = () => { },
  loadMoreInbox = () => { },
  isFetchingInbox = false,
  recordingId = null
}) {
  return (
    <_Component className={_utils.cx(_styles, "pagewrap")} tag="div">
      <_Builtin.Block
        className={_utils.cx(_styles, "icon_main-menu")}
        tag="div"
      >
        <_Builtin.Link
          className={_utils.cx(_styles, "link-block")}
          button={false}
          block="inline"
          options={{
            href: "#",
          }}
        >
          <_Builtin.Image
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="images/66968578d5889c78730e31bc_star.svg"
          />
        </_Builtin.Link>
      </_Builtin.Block>
      <Sidemenu />
      <_Builtin.Block
        className={_utils.cx(_styles, "maincontent_container")}
        tag="div"
      >
        <Topnav inputDevices={inputDevices} outputDevices={outputDevices}
          onDeviceSelect={onDeviceSelect} agentStatus={agentStatus} onStatusChange={onStatusChange}
        />
        <_Builtin.Block
          className={_utils.cx(_styles, "maincontent_body", "bg-gray")}
          tag="div"
        >
          <_Builtin.TabsWrapper
            className={_utils.cx(_styles, "tabs-main")}
            current="Tab 1"
            easing="ease"
            fadeIn={300}
            fadeOut={100}
          >
            <_Builtin.TabsMenu
              className={_utils.cx(_styles, "tabsmenu-main")}
              tag="div"
            >
              <_Builtin.TabsLink
                className={_utils.cx(_styles, "tablink-main")}
                data-w-tab="Tab 1"
                block="inline"
              >
                <_Builtin.HtmlEmbed
                  className={_utils.cx(_styles, "svg-icon-embed")}
                  value="%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%20100%22%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3Cstyle%3E%0A%20%20%20%20%20%20.cls-1%20%7B%0A%20%20%20%20%20%20%20%20fill%3A%20CurrentColor%3B%0A%20%20%20%20%20%20%20%20stroke-width%3A%200px%3B%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%3C%2Fstyle%3E%0A%20%20%3C%2Fdefs%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M50.01%2C81.7c-13.33%2C0-26.66%2C0-39.99%2C0-4.02%2C0-4.74-.74-4.74-4.82%2C0-10.07-.03-20.14.04-30.21%2C0-1.23.29-2.56.83-3.66%2C3.56-7.32%2C7.27-14.56%2C10.82-21.88.96-1.99%2C2.28-2.84%2C4.48-2.83%2C19.03.05%2C38.07.05%2C57.1%2C0%2C2.2%2C0%2C3.52.83%2C4.49%2C2.82%2C3.55%2C7.32%2C7.25%2C14.57%2C10.82%2C21.88.51%2C1.05.82%2C2.32.83%2C3.49.06%2C10.36.04%2C20.72.04%2C31.08%2C0%2C3.18-.96%2C4.13-4.2%2C4.13-13.5%2C0-27.01%2C0-40.51%2C0ZM88.61%2C48.75c-.25-.08-.41-.18-.57-.18-5.82-.01-11.64-.05-17.46.03-.49%2C0-1.17.77-1.43%2C1.34-1.69%2C3.79-4.05%2C7.03-7.38%2C9.56-8.41%2C6.37-25.15%2C6.08-31.7-9.29-.53-1.25-1.11-1.75-2.52-1.72-4.77.1-9.55.04-14.32.04-.61%2C0-1.22.07-1.78.1v26.83h77.17v-26.73ZM86.66%2C42.45c-.11-.4-.13-.63-.23-.83-2.69-5.41-5.35-10.84-8.12-16.21-.26-.5-1.14-.94-1.74-.94-17.69-.05-35.38-.03-53.07-.06-.99%2C0-1.56.28-2.01%2C1.21-2.55%2C5.22-5.17%2C10.41-7.75%2C15.62-.16.33-.22.7-.38%2C1.22%2C5.87%2C0%2C11.57%2C0%2C17.27%2C0%2C2.61%2C0%2C3.29.58%2C4.11%2C3.09%2C1.59%2C4.91%2C4.26%2C8.93%2C9.33%2C10.82%2C8.8%2C3.29%2C17.35-1.33%2C20.21-10.87.72-2.41%2C1.5-3.03%2C3.97-3.04%2C2.79-.02%2C5.59%2C0%2C8.38%2C0%2C3.31%2C0%2C6.61%2C0%2C10.04%2C0Z%22%2F%3E%0A%3C%2Fsvg%3E"
                />
                <_Builtin.Block tag="div">{"Inbox"}</_Builtin.Block>
              </_Builtin.TabsLink>
              <_Builtin.TabsLink
                className={_utils.cx(_styles, "tablink-main")}
                data-w-tab="Tab 2"
                block="inline"
              >
                <_Builtin.HtmlEmbed
                  className={_utils.cx(_styles, "svg-icon-embed")}
                  value="%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20id%3D%22Layer_1%22%20data-name%3D%22Layer%201%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20100%20100%22%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3Cstyle%3E%0A%20%20%20%20%20%20.cls-1%20%7B%0A%20%20%20%20%20%20%20%20fill%3A%20CurrentColor%3B%0A%20%20%20%20%20%20%20%20stroke-width%3A%200px%3B%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%3C%2Fstyle%3E%0A%20%20%3C%2Fdefs%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M8.69%2C55.69c2.06%2C0%2C4.16.02%2C6.25%2C0%2C1.32-.01%2C2.68.09%2C2.63%2C1.79-.05%2C1.65-1.41%2C1.76-2.72%2C1.75-2.46-.01-4.93.02-7.39-.01-1.91-.02-2.42-.62-2.51-2.56-.2-4.05.25-7.94%2C3.48-10.8%2C1.5-1.32%2C3.36-2.23%2C5.14-3.38-1.3-3.86-1.81-7.9%2C2.08-11.06%2C2.69-2.19%2C5.78-2%2C9.61.38%2C4.79-11.24%2C13.1-17.73%2C25.49-17.43%2C11.67.28%2C19.5%2C6.7%2C24.01%2C17.46%2C3.36-2.42%2C6.87-2.9%2C10.06-.01%2C3.41%2C3.08%2C3%2C6.95%2C1.49%2C10.96.68.27%2C1.4.49%2C2.06.82%2C4.41%2C2.18%2C6.65%2C5.76%2C6.7%2C10.68.05%2C4.97.04%2C4.97-4.85%2C4.97-4.52%2C0-9.03%2C0-13.55%2C0-.41%2C0-.82%2C0-1.23%2C0-1.19-.03-2.15-.49-2.15-1.8%2C0-1.33.96-1.73%2C2.17-1.73%2C4.63%2C0%2C9.27%2C0%2C13.9%2C0%2C.64%2C0%2C1.27%2C0%2C1.88%2C0%2C1.08-4.37-1.87-8.96-6.19-9.4-2.9-.3-5.86-.19-8.78-.11-.43.01-1.04.79-1.21%2C1.32-2.83%2C8.92-8.61%2C15.04-17.57%2C17.68-9.88%2C2.92-18.63.49-26.03-6.68-.41-.4-.68-.96-1.07-1.53-5.58%2C5.58-10.84%2C10.85-16.1%2C16.11-1.24%2C1.24-2.52%2C2.46-3.71%2C3.75-1.33%2C1.44-1.31%2C3.16-.06%2C4.4%2C1.24%2C1.22%2C3%2C1.24%2C4.4-.12%2C3.48-3.4%2C6.89-6.88%2C10.36-10.29.44-.43%2C1.02-.97%2C1.56-1%2C.58-.03%2C1.57.35%2C1.71.77.21.63.08%2C1.68-.34%2C2.16-1.46%2C1.68-3.1%2C3.2-4.67%2C4.77-1.95%2C1.95-3.88%2C3.92-5.85%2C5.84-3.01%2C2.94-7%2C3.05-9.71.31-2.67-2.71-2.58-6.63.34-9.58%2C6.06-6.13%2C12.15-12.23%2C18.3-18.27%2C1.1-1.07%2C1.35-1.81.53-3.22-.96-1.65-1.42-3.58-2.23-5.32-.23-.5-.9-1.1-1.39-1.12-2.46-.11-4.93-.13-7.38%2C0-5.09.26-8.24%2C4.25-7.46%2C9.54ZM50.02%2C62.79c12.39%2C0%2C22.49-10.07%2C22.52-22.45.02-12.36-10.06-22.51-22.43-22.57-12.4-.07-22.63%2C10.15-22.6%2C22.57.02%2C12.38%2C10.13%2C22.45%2C22.52%2C22.45ZM23.98%2C37.94c0-2.74-1.47-4.48-3.81-4.51-2.41-.04-3.94%2C1.73-3.93%2C4.57%2C0%2C2.74%2C1.47%2C4.48%2C3.81%2C4.52%2C2.41.04%2C3.94-1.74%2C3.94-4.57ZM83.81%2C38.05c.01-2.85-1.48-4.62-3.88-4.62-2.35%2C0-3.85%2C1.74-3.86%2C4.46-.01%2C2.85%2C1.48%2C4.63%2C3.88%2C4.62%2C2.35%2C0%2C3.85-1.75%2C3.86-4.47Z%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M33.8%2C67.14c-.64.43-1.24%2C1.12-1.93%2C1.22-1.08.16-1.87-.68-1.63-1.71.15-.65%2C1.03-1.56%2C1.61-1.58.65-.02%2C1.33.83%2C2%2C1.3-.01.26-.03.52-.04.77Z%22%2F%3E%0A%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M50.05%2C59.29c-10.51.01-19.04-8.51-19.03-19%2C0-10.46%2C8.62-19.04%2C19.07-19%2C10.39.04%2C18.91%2C8.56%2C18.94%2C18.95.03%2C10.5-8.48%2C19.05-18.98%2C19.06ZM62.21%2C49.6c4.99-5.33%2C4.24-15.1-1.62-20.58-6.32-5.9-16.04-5.53-21.92.8-6.02%2C6.48-4.69%2C15.91-.97%2C19.55%2C2.2-1.83%2C4.37-3.63%2C6.55-5.44-2.59-4-1.48-9.01.79-11.06%2C2.48-2.25%2C6.24-2.75%2C8.89-.76%2C1.19.9%2C2.3%2C2.26%2C2.82%2C3.64%2C1.1%2C2.91.64%2C5.83-1.08%2C8.38%2C1.32.88%2C2.56%2C1.56%2C3.63%2C2.45%2C1.07.89%2C1.96%2C2%2C2.92%2C3.01ZM59.51%2C52.33c-2.1-3.67-5.31-5.6-9.48-5.61-4.18%2C0-7.39%2C1.93-9.49%2C5.6%2C4.85%2C4.55%2C14.09%2C4.55%2C18.97%2C0ZM53.73%2C38.78c0-2.65-1.51-4.41-3.75-4.37-2.24.03-3.68%2C1.79-3.66%2C4.47.03%2C2.62%2C1.41%2C4.22%2C3.66%2C4.24%2C2.33.02%2C3.75-1.62%2C3.75-4.33Z%22%2F%3E%0A%3C%2Fsvg%3E"
                />
                <_Builtin.Block tag="div">{"Leads"}</_Builtin.Block>
              </_Builtin.TabsLink>
            </_Builtin.TabsMenu>
            <_Builtin.TabsContent
              className={_utils.cx(_styles, "tabscontent_main")}
              tag="div"
            >
              <_Builtin.TabsPane tag="div" data-w-tab="Tab 1">
                <Inbox
                  dialerHandler={dialerHandler}
                  dialerLoading={dialerLoading}
                  interactionsData={interactionsData}
                  dataCollectHandler={dataCollectHandler}
                  handleSendingMessage={handleSendingMessage}
                  transcriptionData={transcriptionData}
                  handleTranscriptMessage={handleTranscriptMessage}
                  handleClickInteraction={handleClickInteraction}
                  callStatus={callStatus}
                  handleHangUp={handleHangUp}
                  inboxes={inboxes}
                  handleClickUserInbox={handleClickUserInbox}
                  currentLead={currentLead}
                  baseInfo={baseInfo}
                  incomingCallInfo={incomingCallInfo}
                  loadMore={loadMore}
                  loadMoreInbox={loadMoreInbox}
                  isFetchingInbox={isFetchingInbox}
                  isLoadingMore={isLoadingMore}
                  isFetchingInteractions={isFetchingInteractions}
                  isFetchingTanscriptions={isFetchingTanscriptions}
                  leadLoading={leadLoading}
                  callErrorMsg={callErrorMsg}
                  openModalKeypad={openModalKeypad}
                  interactionId={interactionId}
                  recordingId={recordingId}
                />
              </_Builtin.TabsPane>
              <_Builtin.TabsPane tag="div" data-w-tab="Tab 2">
                <Leads dialerHandler={dialerHandler} callStatus={callStatus} handleHangUp={handleHangUp} leadsData={leadsData} openModalKeypad={openModalKeypad}
                  leadTableLoading={leadTableLoading} history={history} historyLoading={historyLoading} handlerRowClick={handlerRowClick}
                  handleHistoryClick={handleHistoryClick} interLeadsLoading={interLeadsLoading} isFetchingTanscriptions={isFetchingTanscriptions}
                  interDataLeads={interDataLeads} transLeadData={transLeadData} transLeadsLoading={transLeadsLoading} handleClickInterLeads={handleClickInterLeads}
                  leadBaseInfo={leadBaseInfo} loadMoreLeads={loadMoreLeads} isLeadsLoadingMore={isLeadsLoadingMore} loadMoreInter={loadMoreInter} callErrorMsg={callErrorMsg}
                  isLoadingMore={isLoadingMore} filter={filter} handleStatusChange={handleStatusChange}
                />
              </_Builtin.TabsPane>
            </_Builtin.TabsContent>
          </_Builtin.TabsWrapper>
        </_Builtin.Block>
      </_Builtin.Block>
      <UploadProvider>
        <PopupImport leadsData={leadskey} />
      </UploadProvider>
      <IncomingCall callStatus={callStatus} handleHangUp={handleHangUp} handleAcceptCall={handleAcceptCall}
        {...incomingCallInfo}
      />
    </_Component>
  );
}
